/**
 * Determina qué equipos puede ver un usuario según su rol
 * @param {Object} userProfile - Perfil del usuario con role y team
 * @returns {Array|null} - Array de equipos permitidos o null si puede ver todos
 */
export const getAllowedTeams = (userProfile) => {
  if (!userProfile) return null;

  // Admin puede ver todos los equipos
  if (userProfile.role === 'admin') {
    return null;
  }

  // Entrenadores
  if (userProfile.role === 'entrenador') {
    if (userProfile.team === 'Amateur') {
      // Entrenador de Amateur ve todos los equipos
      return null;
    } else {
      // Entrenadores de Juvenil y Cadete solo ven Juvenil y Cadete
      return ['Juvenil', 'Cadete'];
    }
  }

  // Por defecto, solo ve su equipo
  return userProfile.team ? [userProfile.team] : null;
};

/**
 * Obtiene la lista de equipos disponibles para el selector
 * @param {Object} userProfile - Perfil del usuario con role y team
 * @returns {Array} - Array de equipos para mostrar en el selector
 */
export const getTeamOptions = (userProfile) => {
  if (!userProfile) return ['Todos', 'Juvenil', 'Cadete', 'Amateur'];

  // Admin puede seleccionar todos
  if (userProfile.role === 'admin') {
    return ['Todos', 'Juvenil', 'Cadete', 'Amateur'];
  }

  // Entrenadores
  if (userProfile.role === 'entrenador') {
    if (userProfile.team === 'Amateur') {
      // Entrenador de Amateur puede seleccionar todos
      return ['Todos', 'Juvenil', 'Cadete', 'Amateur'];
    } else {
      // Entrenadores de Juvenil y Cadete solo ven Juvenil y Cadete
      return ['Todos', 'Juvenil', 'Cadete'];
    }
  }

  // Por defecto, solo su equipo
  return [userProfile.team];
};

/**
 * Aplica el filtro de equipos a una query de Supabase
 * @param {Object} query - Query de Supabase
 * @param {Array|null} allowedTeams - Array de equipos permitidos o null
 * @param {string} selectedTeam - Equipo seleccionado actualmente (puede ser 'Todos')
 * @returns {Object} - Query modificada
 */
export const applyTeamFilter = (query, allowedTeams, selectedTeam = 'Todos') => {
  if (selectedTeam !== 'Todos') {
    // Si hay un equipo específico seleccionado, filtrar por ese equipo
    return query.eq('team', selectedTeam);
  } else if (allowedTeams) {
    // Si hay restricción de equipos y está en "Todos", filtrar por los permitidos
    return query.in('team', allowedTeams);
  }
  // Sin restricciones, devolver la query sin modificar
  return query;
};
